module.exports = __webpack_public_path__ + "static/media/Teil_1_Backward.f7d73214.ogv";


//////////////////
// WEBPACK FOOTER
// ./src/Teil_1_Backward.ogv
// module id = 118
// module chunks = 0